/* v8 ignore file -- @preserve */
import { computed } from 'vue';
import { GET_EXPERIMENTS_CLIENT_IDS } from '#shared/types/getters';

export default function useExperimentsClientIds() {
  const navExperimentation = useNavExperimentation();
  return computed(() => navExperimentation?.[GET_EXPERIMENTS_CLIENT_IDS]);
}
